import { apiSlice } from "../apiSlice";

export const departmentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //     {
    //   "org_id": 0,
    //   "name": "string",
    //   "description": "string"
    // }
    getDepartmentsList: builder.query({
      query: ({ org_id }) => `/org/department/list/?org_id=${org_id}`,
      keepUnusedDataFor: 0,
    }),
    postDepartment: builder.mutation({
      query: (deptData) => ({
        url: "/org/department/",
        method: "POST",
        body: deptData,
      }),
    }),
    putDepartment: builder.mutation({
      query: (deptData) => ({
        url: "/org/department/",
        method: "PUT",
        body: deptData,
      }),
    }),
    deleteDepartment: builder.mutation({
      query: (department_id) => ({
        url: `/org/department/?department_id=${department_id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  usePostDepartmentMutation,
  useGetDepartmentsListQuery,
  usePutDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentsApiSlice;
